import React from "react";
import { ArrowRight, Layers2, Trees, BadgeCheck } from "lucide-react";
import { PlantationDrawing } from "./ProcessDrawings";

export const AgroFlow = ({ tid }) => (
  <div className="agro-flow" data-testid={tid("agro-flows")}>
    <svg className="agro-connector" viewBox="0 0 40 352" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 185H10Q20 185 20 169V32Q20 20 32 20H40" fill="none" stroke="var(--green-light)" strokeWidth="1.5" className="flow-line" />
    </svg>
    <div className="agro-flow-content">
      <div className="agro-material" data-testid={tid("agro-biochar-flow-node")}>
        <Layers2 size={22} strokeWidth={1.3} aria-hidden="true" /><strong>Salida 2 · Biochar</strong><ArrowRight size={17} aria-hidden="true" /><span>Carbono estable que se incorpora al suelo de cualquier plantación</span>
      </div>
      <PlantationDrawing testId={tid("agro-plantation-diagram")} />
      <div className="agro-co2" data-testid={tid("agro-trees-node")}>
        <Trees size={20} strokeWidth={1.3} aria-hidden="true" />
        <div>
          <strong>Plantamos castaños y pecanes para eliminar aún más CO₂</strong>
          <p>Los árboles capturan carbono en madera y suelo, además del que ya fija el biochar. Parte de los beneficios de cada proyecto se reinvierte en nuevas plantaciones.</p>
        </div>
      </div>
      <p className="agro-cert" data-testid={tid("agro-cert")}><BadgeCheck size={14} strokeWidth={1.5} aria-hidden="true" />Eliminación de carbono medible y certificable · EBC Biochar · Puro.earth</p>
    </div>
  </div>
);
